<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-add-button/lesson-add-button.component.ts.LessonAddButtonComponent.html